<template>
    <div class="secondary-c">
        <edit-input class="tw-mr-4 tw-w-full" label="Facebook" icon="fab fa-facebook-square">
            <form-input v-model="settings.profile.facebook" name="facebook" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" label="Twitter" icon="fab fa-twitter">
            <form-input v-model="settings.profile.twitter" name="twitter" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" label="Instagram" icon="fab fa-instagram">
            <form-input v-model="settings.profile.instagram" name="instagram" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" label="Pinterest" icon="fab fa-pinterest">
            <form-input v-model="settings.profile.pinterest" name="pinterest" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" label="Linkedin" icon="fab fa-linkedin">
            <form-input v-model="settings.profile.linkedin" name="linkedin" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" label="Website" icon="far fa-link">
            <form-input v-model="settings.profile.website" name="website" type="text"></form-input>
        </edit-input>

        <div @click="saveAccount" class="general-button">{{ $t('fields.save') }} </div>
    </div>
</template>

<script>
import EditInput from '../EditInput.vue';
export default {
    name: 'SocialTab',

    components: {
        'edit-input': EditInput,
    },
    props: ['settings'],
    data() {
        return {
        }
    },
    methods: {
        saveAccount() {
            this.$emit('saveAccount');
        }
    },
}
</script>